import Modal from "../../UI/Modal";
import { useHappyNewYear } from "../../../hooks/useHappyNewYear";

const HappyNewYear = () => {
  const {
    showHappyNewYearModal,
    setShowHappyNewYearModal,
    currentYear,
  } = useHappyNewYear();
  return (
    <Modal
      closeFunc={() => setShowHappyNewYearModal(false)}
      openStatus={showHappyNewYearModal}
      panelStyles="relative mx-auto h-[85vh] w-[70%] overflow-hidden rounded-[20px] bg-[#191a1c] text-white outline-none xl:max-h-[750px] xl:max-w-[1250px]"
    >
      <div className="mt-[10rem] flex h-full w-full items-center justify-center">
        <div className="w-[55%] text-center">
          <h1 className="font-oregano text-[53px]">Happy New Year!</h1>
          <p className="mb-12 font-manrope text-base">
            Wishing you an amazing {currentYear}! ✨ May this year bring new
            goals, exciting challenges, and big wins. Can’t wait to see what we
            achieve together.
          </p>
          <button
            onClick={() => {
              setShowHappyNewYearModal(false);
            }}
            className="w-full max-w-[130px] rounded-[4px] bg-gradient-to-r from-[#6E35FF] to-[#7F4DFF]  px-[10px] py-3"
          >
            Close
          </button>
        </div>
        <p className="absolute bottom-4 left-[50%] flex translate-x-[-50%] items-center gap-1 font-red-hat italic">
          <img src="/star.png" alt="star" width={10} height={10} />
          www.reachcinema.io
        </p>
      </div>
      <img
        className="absolute bottom-0 right-0 h-[26rem] w-auto"
        src="/fatherChristmas.png"
        alt="fatherChristmas"
        width={416}
        height={416}
      />

      <img
        className="absolute top-3 w-full"
        src="/christmasRope.png"
        alt="rope"
        width={1200}
        height={120}
      />

      <img
        className="absolute bottom-0 left-0 h-auto w-[9rem]"
        src="/bigGiftBox.png"
        alt="gift"
        width={200}
        height={200}
      />

      <img
        className="absolute bottom-[10rem] left-12 h-auto w-[5rem]"
        src="/smallGiftBox.png"
        alt="gift"
        width={120}
        height={120}
      />

      <img
        className="absolute left-[3.8rem] top-[2.8rem] h-auto w-[3rem]"
        src="/orangeLamp.png"
        alt="lamp"
        width={64}
        height={64}
      />

      <img
        className="z-1 absolute left-[1rem] top-[0.7rem] h-auto w-[10rem]"
        src="/orangeGlow.png"
        alt="glow"
        width={220}
        height={120}
      />

      <img
        className="absolute left-[8rem] top-[2.5rem] h-auto w-[3rem]"
        src="/angel.png"
        alt="angel"
        width={64}
        height={64}
      />

      <img
        className="absolute left-[14rem] top-[2.5rem] h-auto w-[3rem]"
        src="/pinkLamp.png"
        alt="lamp"
        width={64}
        height={64}
      />

      <img
        className="z-1 absolute left-[10rem] top-[1rem] h-auto w-[11rem]"
        src="/pinkGlow.png"
        alt="glow"
        width={240}
        height={140}
      />

      <img
        className="absolute left-[24rem] top-[2.4rem] h-auto w-[3rem]"
        src="/blueLamp.png"
        alt="lamp"
        width={64}
        height={64}
      />

      <img
        className="z-1 absolute left-[20rem] top-[0.8rem] h-auto w-[11rem]"
        src="/blueGlow.png"
        alt="glow"
        width={240}
        height={140}
      />

      <img
        className="absolute right-[24rem] top-[2.3rem] h-auto w-[3rem]"
        src="/purpleLamp.png"
        alt="lamp"
        width={64}
        height={64}
      />

      <img
        className="z-1 absolute right-[20rem] top-[0.7rem] h-auto w-[11rem]"
        src="/purpleGlow.png"
        alt="glow"
        width={240}
        height={140}
      />

      <img
        className="absolute right-[13rem] top-[2.6rem] h-auto w-[3rem]"
        src="/orangeLamp.png"
        alt="lamp"
        width={64}
        height={64}
      />

      <img
        className="z-1 absolute right-[8.6rem] top-[0.5rem] h-auto w-[10rem]"
        src="/orangeGlow.png"
        alt="glow"
        width={220}
        height={120}
      />

      <img
        className="absolute right-[3.8rem] top-[2.8rem] h-auto w-[3rem]"
        src="/redLamp.png"
        alt="lamp"
        width={64}
        height={64}
      />

      <img
        className="z-1 absolute right-[0.5rem] top-[0.4rem] h-auto w-[11rem]"
        src="/redGlow.png"
        alt="glow"
        width={240}
        height={140}
      />
    </Modal>
  );
};

export default HappyNewYear;
